// Subject « Calendrier » — agenda of open + upcoming questionnaires.
export const calendar = {
  calendar_tab_label: "Calendrier",
  calendar_due_before: "À faire avant le {{date}}",
  calendar_opens_on: "S'ouvre le {{date}}",
  calendar_next_time: "Prochaine fois : {{date}}",
  calendar_empty: "Rien de prévu pour le moment",
};
